export const cartModels = [
  {
    name: 'shoppingCart',
    fields: [
      'cookie',
      'discount',
      'id',
      'shippingFee',
      'source',
      'subtotal',
      'tax',
      'total',
      'promotion',
    ],
    collectionPath: 'shopping_carts',
    relationships: {
      customer: { jsonApi: 'hasOne', type: 'customer' },
      site: { jsonApi: 'hasOne', type: 'site' },
      items: { jsonApi: 'hasMany', type: 'item' },
    },
  },
  {
    name: 'item',
    fields: [
      'applyTax',
      'id',
      'applyTax',
      'desc',
      'inventory',
      'maxQuantity',
      'name',
      'options',
      'price',
      'promoAdj',
      'promoCode',
      'promoId',
      'promoPrice',
      'promoType',
      'quantity',
      'shopItemId',
      'subscription',
      'subscriptionEnd',
      'subscriptionStart',
      'tax',
    ],
    collectionPath: 'items',
    relationships: {
      shoppingCart: { jsonApi: 'hasOne', type: 'shoppingCart' },
      shopItem: { jsonApi: 'hasOne', type: 'shopItem' },
      shopItemImages: { jsonApi: 'hasMany', type: 'shopItemImage' },
    },
  },
]
